import { requests, mainApiRoot } from './index'

export const Reports = {
  get: id => requests.get(mainApiRoot, `/domains/${id}/reports`),
  getPrevious: (domainId, reportId) =>
    requests.get(mainApiRoot, `/domains/${domainId}/reports/${reportId}`),
  create: (id, payload) =>
    requests.post(mainApiRoot, `/domains/${id}/reports`, {
      report: payload
    }),
  update: (domainId, reportId, payload) =>
    requests.put(mainApiRoot, `/domains/${domainId}/reports/${reportId}`, {
      report: payload
    }),
  del: (domainId, id) => requests.del(mainApiRoot, `/domains/${domainId}/reports/${id}`),
  export: (domainId, reportId, dateFrom, dateTo) =>
    requests.getFile(
      mainApiRoot,
      `/domains/${domainId}/reports/${reportId}/download_pdf?date_from=${dateFrom}&date_to=${dateTo}`
    ),
  deleteLogo: (domainId, id) =>
    requests.del(mainApiRoot, `/domains/${domainId}/reports/${id}/delete_logo`)
}